module.exports = __webpack_public_path__ + "static/media/lists-page.92ed6efb.png";